import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  status: string;
  latestChapter: string;
  rating: number;
  views: number;
  tags: string[];
  category?: string;
  updateTime?: string;
}

export default function ComicCard({ id, title, author, coverImage, status, latestChapter, rating, views, tags }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) {
      return (v / 10000).toFixed(1) + '万';
    }
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="comic-card-hover group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverImage}
          alt={`${title} - 古古漫画网`}
          title={`${title} - 古古漫画网免费全集下拉式阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 text-accent-300 text-xs px-1.5 py-0.5 rounded-full">
          <i className="ri-star-fill text-[10px]"></i>
          <span>{rating}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 text-[10px] bg-accent-100 text-accent-700 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-2 pt-2 border-t border-background-200">
          <p className="text-[11px] text-foreground-500 line-clamp-1">{latestChapter}</p>
          <div className="flex items-center justify-between mt-1">
            <span className="text-[11px] text-foreground-400">
              <i className="ri-eye-line mr-0.5"></i>{formatViews(views)}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}